<template>
  <div>
    <v-overlay
      v-model="loadingOverlay"
      color="rgba(255, 255, 255, 0.85)"
      opacity="0.85"
      z-index="7"
      light
    >
      <div class="flower-spinner ma-auto">
        <div class="dots-container">
          <div class="bigger-dot">
            <div class="smaller-dot"></div>
          </div>
        </div>
      </div>

      <div class="black--text text-center mt-5">
        <span class="text-h6 font-weight-bold"
          >{{
            processingCC
              ? $t("order_step_3_creditcard_auth_text")
              : $t("order_step_3_order_dealing")
          }}<br /><span v-html="$t('order_step_3_plz_waiting')"></span></span
        ><br />
        Your order’s being processed.<br />
        Please wait patiently and don’t refresh this page.

        <!-- <div
          v-if="processingCC && cc3DUrl !== ''"
          class="grey lighten-1 px-8 py-2 mt-10"
        >
          {{ $t("order_step_3_click_to_outer_link") }}
          <a :href="cc3DUrl" target="_blank" class="primary-1--text">{{
            $t("order_step_3_outer_link")
          }}</a>
        </div> -->
      </div>
    </v-overlay>
    <OrderTemplate :step="4" :steps="steps">
      <template slot="paymentSummary">
        <TicketTable
          :thead="thead"
          :tickets="reserveResponse ? reserveResponse.tickets : []"
          :discount="updateResponse.discountAmount || 0"
          :isShippingFee="selectedGetWay && selectedGetWay.type == 'post'"
          :shippingFee="shippingFee"
        >
          <template slot="title">{{
            $t(
              `order_step_2_ticket_table_title${
                campaign.isLottery ? "_lottery" : ""
              }`
            )
          }}</template>
        </TicketTable>
      </template>
      <template slot="Contents">
        <CustomCard v-if="welfareFee" id="welfareFee">
          <template v-slot:title>
            <div
              class="text-center bg-tranparent-yellow pa-3 text-title font-weight-bold"
            >
              {{ $t("ticket_table_welfare") }}
            </div>
          </template>
          <v-col
            cols="12"
            lg="8"
            md="8"
            :class="`mx-auto ${
              isSubmit && currentID === 'welfareFee' && welfareFee.type === ''
                ? 'is-need-value'
                : ''
            }`"
            id="welfareFee"
          >
            <v-radio-group v-model="welfareFee">
              <v-radio :value="true" color="primary" class="radioStyle pa-4">
                <template slot="label">
                  <div>
                    {{ $t("ticket_table_welfare") }}
                    <br /><span class="text-eight">{{
                      $t("ticket_table_welfare_fee_info")
                    }}</span>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </CustomCard>
        <CustomCard v-if="getWays.length" id="getWay">
          <template v-slot:title>
            <div
              class="text-center bg-tranparent-yellow pa-3 text-title font-weight-bold"
            >
              {{ $t("orderlist_get_type") }}
            </div>
          </template>
          <v-col
            cols="12"
            lg="8"
            md="8"
            :class="`mx-auto ${
              isSubmit &&
              currentID === 'selectedGetWay' &&
              selectedGetValue === ''
                ? 'is-need-value'
                : ''
            }`"
            id="selectedGetWay"
          >
            <v-radio-group v-model="selectedGetValue">
              <template v-for="(getWay, i) in getWayOptions">
                <v-radio
                  :key="i"
                  :value="getWay.type"
                  color="primary"
                  class="radioStyle pa-4"
                  :class="{ 'mt-4': i !== 0 }"
                  v-if="!(getWay.type === 'post' && !isInPostLimit)"
                  @change="doSelectGet(getWay)"
                >
                  <template slot="label">
                    <div class="d-flex flex-column">
                      <div class="d-flex align-center">
                        <template v-if="getWay.type === 'famiport'">
                          <v-img
                            src="@/assets/image/logo-fm@3x.png"
                            max-width="25"
                            class="mr-1"
                          />
                        </template>
                        <template v-if="getWay.type === 'ibon'">
                          <v-img
                            src="@/assets/image/logo-ibon@3x.png"
                            max-width="140"
                            class="mr-1"
                          />
                        </template>
                        <span v-if="getWay.type !== 'ibon'" class="getWayName">
                          {{ getWay.name }}
                        </span>
                        <v-tooltip top max-width="320">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-if="getWay.tips" v-bind="attrs" v-on="on">
                              <v-icon class="ml-1" dense
                                >mdi-information-outline</v-icon
                              >
                            </span>
                          </template>
                          <span v-html="getWay.tips"></span>
                        </v-tooltip>
                      </div>

                      <div
                        class="text-eight mt-2"
                        v-html="getWay.descript"
                      ></div>
                    </div>
                    <v-spacer class="mr-1" />
                    <div class="getWayAppend">
                      {{ getWay.other }}
                    </div>
                  </template>
                </v-radio>
                <template
                  v-if="getWay.type === 'post' && selectedGetValue === 'post'"
                >
                  <div
                    id="pickup-custom"
                    class="grey-1 pa-5"
                    :key="getWay.type"
                  >
                    <div
                      class="text-nine font-weight-bold"
                      :class="$vuetify.breakpoint.xs ? '' : 'px-5'"
                    >
                      {{ $t("order_step_3_receiver_info") }}*
                    </div>
                    <v-radio-group v-model="selectedPickupAddress">
                      <template
                        v-if="
                          maskedUserInfo.country === 'Taiwan' &&
                          maskedUserInfo.userName &&
                          maskedUserInfo.address
                        "
                      >
                        <v-radio
                          id="envoiceUserInfo"
                          value="1"
                          color="primary"
                          :class="$vuetify.breakpoint.xs ? '' : 'pa-4'"
                        >
                          <template slot="label">
                            <template v-if="maskedUserInfo.userName">
                              {{ maskedUserInfo.userName }}&nbsp;&nbsp;
                            </template>
                            <template v-if="maskedUserInfo.mobile">
                              {{ maskedUserInfo.mobile }}<br />
                            </template>
                            <template v-if="maskedUserInfo.address">
                              {{ maskedUserInfo.address.split(",")[0] }}
                              {{ maskedUserInfo.address.split(",")[1] }}
                              {{ maskedUserInfo.address.split(",")[2] }}
                              {{ maskedUserInfo.address.split(",")[3] }}
                            </template>
                          </template>
                        </v-radio>
                        <v-divider />
                      </template>
                      <v-radio
                        v-if="selectedPickupAddress === '2'"
                        id="pickupCustomeInfo"
                        value="2"
                        color="primary"
                        :class="$vuetify.breakpoint.xs ? '' : 'pa-4'"
                      >
                        <template slot="label">
                          <v-form class="mt-5">
                            <v-row>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  :error="
                                    hasPickupInvalid &&
                                    !!invalidPickupError.name &&
                                    pickupInfo.name === ''
                                  "
                                  :error-messages="
                                    hasPickupInvalid &&
                                    !!invalidPickupError.name
                                      ? [invalidPickupError.name]
                                      : null
                                  "
                                  v-model="pickupInfo.name"
                                  :label="$t('userinfo_name')"
                                  outlined
                                  background-color="white"
                                  color="primary-1"
                                  reqired
                                  :autofocus="true"
                                  @change="pickupFormRequired"
                                  @blur="pickupFormRequired"
                                >
                                  <template #message="{ message }">
                                    {{ $t(message) }}
                                  </template>
                                </v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  :error="
                                    hasPickupInvalid &&
                                    !!invalidPickupError.mobile &&
                                    pickupInfo.mobile === ''
                                  "
                                  :error-messages="
                                    hasPickupInvalid &&
                                    !!invalidPickupError.mobile
                                      ? [invalidPickupError.mobile]
                                      : null
                                  "
                                  v-model="pickupInfo.mobile"
                                  :label="$t('userinfo_phone_number')"
                                  outlined
                                  background-color="white"
                                  color="primary-1"
                                  @change="pickupFormRequired"
                                >
                                  <template #message="{ message }">
                                    {{ $t(message) }}
                                  </template>
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="">
                                <RegionSelect
                                  :hasInvalid="hasPickupInvalid"
                                  :invalidError="invalidPickupError"
                                  :onlyLocale="true"
                                  :propsCountry="'Taiwan'"
                                  :propsCounty="pickupInfo.county"
                                  :propsDistrict="pickupInfo.district"
                                  :propsAddress="pickupInfo.address"
                                  :propsPostalCode="pickupInfo.postalCode"
                                  @updateAddress="emitUpdatePickupAddress"
                                />
                              </v-col>
                            </v-row>
                          </v-form>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <div
                      @click="setNewUserInfo"
                      v-if="
                        !selectedPickupAddress || selectedPickupAddress === '1'
                      "
                      :class="{
                        'mx-4': !$vuetify.breakpoint.xs,
                        'pink-1 py-2':
                          isSubmit &&
                          ['pickupCustomeInfo', 'selectedGetWay'].includes(
                            currentID
                          ),
                      }"
                      class="cursor-pointer text-nine"
                    >
                      <v-icon class="mr-1" dense>mdi-plus</v-icon
                      >{{ $t("order_step_3_add_receiver_address") }}
                    </div>
                  </div>
                </template>
              </template>
            </v-radio-group>
          </v-col>
        </CustomCard>
        <CustomCard
          v-if="
            payWays.length &&
            $store.state.event.campaign.payment &&
            !$store.state.event.campaign.payment.includes('FREE')
          "
          id="payWay"
        >
          <template v-slot:title>
            <div
              class="text-center bg-tranparent-yellow pa-3 text-title font-weight-bold"
            >
              {{ $t("orderlist_payment") }}
            </div>
          </template>
          <v-col
            cols="12"
            lg="8"
            md="8"
            :class="`mx-auto ${
              isSubmit &&
              currentID === 'selectedPayWay' &&
              selectedPayWay.type === ''
                ? 'is-need-value'
                : ''
            }`"
            id="selectedPayWay"
          >
            <v-radio-group v-model="selectedPayValue">
              <template v-for="(payWay, i) in payWays">
                <v-radio
                  :value="payWay.type"
                  color="primary"
                  class="radioStyle pa-4"
                  :class="{ 'mt-4': i !== 0 }"
                  @change="selectPayWay(payWay.type)"
                >
                  <template slot="label">
                    <div v-if="payWay.type === 'CC'">
                      {{ $t("orderlist_card_payment_one_time") }}
                      <br />
                      <span class="text-eight">
                        {{ $t("order_step_3_cash_flow_provider") }}
                      </span>
                    </div>
                    <div v-if="payWay.type === 'ATM'">
                      <div class="d-flex align-center">
                        {{ $t("orderlist_virtual_account") }}
                        <v-tooltip top max-width="320">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="primary"
                              class="ml-1"
                              v-bind="attrs"
                              v-on="on"
                              dense
                              >mdi-information-outline</v-icon
                            >
                          </template>
                          <ul class="py-2 text-nine">
                            <li>
                              {{ $t("order_step_3_atm_transfer_note_1") }}
                            </li>
                            <li class="py-2">
                              {{ $t("order_step_3_atm_transfer_note_2") }}
                            </li>
                            <li class="pb-2">
                              {{ $t("order_step_3_atm_transfer_note_3") }}
                            </li>
                            <li>
                              {{ $t("order_step_3_atm_transfer_note_4") }}
                            </li>
                          </ul>
                        </v-tooltip>
                      </div>
                      <div class="text-eight">
                        {{
                          $t("order_step_3_atm_transfer_expired", {
                            atmExpiry: campaign.atmExpiry,
                          })
                        }}
                      </div>
                    </div>
                  </template>
                </v-radio>
                <div
                  class="grey-1 pa-5"
                  :key="payWay.type"
                  v-if="payWay.type == 'CC' && selectedPayWay.type == 'CC'"
                >
                  <v-alert
                    v-model="showInAppBrowserWarning"
                    class="p-4 text-left red--text pink-1 body-2 font-weight-regular rounded-lg"
                    prominent
                    role="alert"
                    type="alert"
                  >
                    <span v-html="$t('in_app_browser_warning')"></span>
                  </v-alert>
                  <template v-if="loadingCCList">
                    <div class="text-center">
                      <v-progress-circular
                        indeterminate
                        color="primary-1"
                        size="25"
                        width="2"
                      ></v-progress-circular>
                    </div>
                  </template>
                  <template v-else>
                    <template v-if="loadCCFailed">
                      <v-btn
                        dark
                        rounded
                        depressed
                        color="light-blue"
                        @click="selectPayWay('CC')"
                      >
                        <v-icon>mdi-replay</v-icon>
                        {{ $t("session_table_retry") }}
                      </v-btn>
                    </template>
                    <template v-else>
                      <div
                        id="add-credit-card"
                        :class="{
                          'px-8': !$vuetify.breakpoint.xs,
                          'pink-1 py-2': currentID === 'add-credit-card',
                        }"
                        class="d-flex align-center"
                      >
                        <div
                          v-if="!ccList.length"
                          @click="updateCCInfo()"
                          class="cursor-pointer"
                        >
                          <v-icon class="mr-1" dense>mdi-plus</v-icon>
                          {{ $t("creditcard_add_new_card") }}
                        </div>
                        <template v-else>
                          <div>
                            <div class="font-weight-bold">
                              {{
                                ccList.find((c) => c.isDefault == "Y")
                                  .issueBankName
                              }}
                            </div>
                            <div style="color: #8d8d8d">
                              {{ ccList.find((c) => c.isDefault == "Y").mchd }}
                            </div>
                            <div class="mt-2">
                              <span class="text-small"
                                >{{ $t("creditcard_expiry_label")
                                }}{{
                                  dateFormat(
                                    ccList.find((c) => c.isDefault == "Y")
                                      .expireYm,
                                    "MM/YY"
                                  )
                                }}</span
                              >
                              <span
                                :class="`expire-tag ${
                                  ccList.find((c) => c.isDefault == 'Y').expired
                                    ? 'expired'
                                    : 'active'
                                }`"
                                >{{
                                  ccList.find((c) => c.isDefault == "Y").expired
                                    ? $t("creditcard_expired_status")
                                    : $t("creditcard_active_status")
                                }}</span
                              >
                            </div>
                          </div>
                          <v-spacer />
                          <div
                            class="primary-1--text cursor-pointer font-weight-bold"
                            @click="updateCCInfo()"
                          >
                            {{ $t("order_step_3_change_creditcard") }}
                          </div>
                        </template>
                      </div>
                      <div
                        class="red--text mt-6"
                        :class="{
                          'text-nine': $vuetify.breakpoint.xs,
                          'px-8': !$vuetify.breakpoint.xs,
                        }"
                      >
                        {{ $t("creditcard_add_new_card_tip") }}
                      </div>
                    </template>
                  </template>
                </div>
              </template>
            </v-radio-group>
          </v-col>
        </CustomCard>
        <CustomCard v-if="needEnvoice" id="envoiceWay">
          <template v-slot:title>
            <div
              class="text-center bg-tranparent-yellow pa-3 text-title font-weight-bold"
            >
              {{ $t("order_step_3_invoice") }}
            </div>
          </template>
          <v-col
            cols="12"
            lg="8"
            md="8"
            :class="`mx-auto ${
              isSubmit &&
              currentID === 'selectedEnvoiceWay' &&
              selectedEnvoice === ''
                ? 'is-need-value'
                : ''
            }`"
            id="selectedEnvoiceWay"
          >
            <v-radio-group
              v-model="selectedEnvoice"
              @change="(v) => (selectedEnvoice = v)"
            >
              <template v-for="(envoiceWay, i) in envoiceWays">
                <v-radio
                  :value="envoiceWay.type"
                  color="primary"
                  class="radioStyle pa-4"
                  :class="{ 'mt-4': i !== 0 }"
                >
                  <template slot="label">
                    <div>
                      {{ envoiceWay.name }}
                      <br /><span class="text-eight">{{
                        envoiceWay.descript
                      }}</span>
                    </div>
                  </template>
                </v-radio>
                <div
                  class="grey-1 pa-5"
                  :key="envoiceWay.type"
                  v-if="
                    envoiceWay.type == 'donate' && selectedEnvoice == 'donate'
                  "
                >
                  <div :class="$vuetify.breakpoint.xs ? '' : 'px-5'">
                    <div class="text-nine font-weight-bold">
                      {{ $t("order_step_3_select_donation_organizer") }}*
                    </div>
                    <v-select
                      v-model="donation"
                      color="primary-1"
                      background-color="white"
                      :items="donateOrganization"
                      :item-text="
                        (donateOrganization) =>
                          `${donateOrganization.code} ${donateOrganization.name}`
                      "
                      :label="$t('order_step_3_donation_organizer')"
                      outlined
                      class="mt-5"
                      :error="
                        hasInvoiceInvalid &&
                        !!invalidInvoiceError.name &&
                        donation === ''
                      "
                      :error-messages="
                        hasInvoiceInvalid && !!invalidInvoiceError.donation
                          ? [invalidInvoiceError.donation]
                          : null
                      "
                      @change="invoiceFormRequired"
                      @blur="invoiceFormRequired"
                    >
                      <template #message="{ message }">
                        {{ $t(message) }}
                      </template>
                    </v-select>
                  </div>
                </div>
                <div
                  class="grey-1 pa-5"
                  :key="envoiceWay.type"
                  v-if="
                    envoiceWay.type == 'duplicate' &&
                    selectedEnvoice == 'duplicate'
                  "
                  id="envoice-custom"
                >
                  <v-form :class="$vuetify.breakpoint.xs ? '' : 'px-5'">
                    <div class="text-nine font-weight-bold">
                      {{ $t("order_step_3_invoice_reward_info") }}*
                    </div>
                    <v-radio-group v-model="selectedEnvoiceAddress">
                      <template
                        v-if="
                          maskedUserInfo.country === 'Taiwan' &&
                          maskedUserInfo.userName &&
                          maskedUserInfo.address
                        "
                      >
                        <v-radio
                          id="envoiceUserInfo"
                          value="1"
                          color="primary"
                          :class="$vuetify.breakpoint.xs ? '' : 'pa-4'"
                        >
                          <template slot="label">
                            <div
                              :class="
                                currentID === 'envoiceUserInfo' ||
                                !selectedEnvoiceAddress
                                  ? 'red--text'
                                  : ''
                              "
                            >
                              <template v-if="maskedUserInfo.userName">
                                {{ maskedUserInfo.userName }}&nbsp;&nbsp;
                              </template>
                              <template v-if="maskedUserInfo.mobile">
                                {{ maskedUserInfo.mobile }}<br />
                              </template>
                              <template v-if="maskedUserInfo.address">
                                {{ maskedUserInfo.address.split(",")[0] }}
                                {{ maskedUserInfo.address.split(",")[1] }}
                                {{ maskedUserInfo.address.split(",")[2] }}
                                {{ maskedUserInfo.address.split(",")[3] }}
                              </template>
                            </div>
                          </template>
                        </v-radio>
                        <v-divider />
                      </template>
                      <v-radio
                        id="envoiceCustomeInfo"
                        v-if="selectedEnvoiceAddress === '2'"
                        value="2"
                        color="primary"
                        :class="{
                          'pa-4': $vuetify.breakpoint.xs,
                          'with-error': hasInvoiceInvalid,
                        }"
                      >
                        <template slot="label">
                          <div>
                            <v-row class="mt-5">
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  v-model="receiptInfo.name"
                                  :label="$t('userinfo_name')"
                                  color="primary-1"
                                  outlined
                                  reqired
                                  :autofocus="true"
                                  background-color="white"
                                  :class="
                                    hasInvoiceInvalid &&
                                    !!invalidInvoiceError.name &&
                                    receiptInfo.name === ''
                                      ? 'error-text'
                                      : ''
                                  "
                                  :error="
                                    hasInvoiceInvalid &&
                                    !!invalidInvoiceError.name &&
                                    receiptInfo.name === ''
                                  "
                                  :error-messages="
                                    hasInvoiceInvalid &&
                                    !!invalidInvoiceError.name
                                      ? [invalidInvoiceError.name]
                                      : null
                                  "
                                  @change="invoiceFormRequired"
                                  @blur="invoiceFormRequired"
                                >
                                  <template #message="{ message }">
                                    {{ $t(message) }}
                                  </template>
                                </v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  v-model="receiptInfo.mobile"
                                  :label="$t('userinfo_phone_number')"
                                  color="primary-1"
                                  outlined
                                  reqired
                                  background-color="white"
                                  :class="
                                    hasInvoiceInvalid &&
                                    !!invalidInvoiceError.name &&
                                    receiptInfo.mobile === ''
                                      ? 'error-text'
                                      : ''
                                  "
                                  :error="
                                    hasInvoiceInvalid &&
                                    !!invalidInvoiceError.name &&
                                    receiptInfo.mobile === ''
                                  "
                                  :error-messages="
                                    hasInvoiceInvalid &&
                                    !!invalidInvoiceError.mobile
                                      ? [invalidInvoiceError.mobile]
                                      : null
                                  "
                                  @change="invoiceFormRequired"
                                  @blur="invoiceFormRequired"
                                >
                                  <template #message="{ message }">
                                    {{ $t(message) }}
                                  </template>
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="">
                                <RegionSelect
                                  :hasInvalid="hasInvoiceInvalid"
                                  :invalidError="invalidInvoiceError"
                                  :onlyLocale="true"
                                  :propsCountry="'Taiwan'"
                                  :propsCounty="receiptInfo.county"
                                  :propsDistrict="receiptInfo.district"
                                  :propsAddress="receiptInfo.address"
                                  :propsPostalCode="receiptInfo.postalCode"
                                  @updateAddress="emitUpdateReceiptAddress"
                                />
                              </v-col>
                            </v-row>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <div
                      @click="setNewInvoiceInfo"
                      v-if="
                        !selectedEnvoiceAddress ||
                        selectedEnvoiceAddress === '1'
                      "
                      :class="{
                        'mx-4': !$vuetify.breakpoint.xs,
                        'pink-1 py-2': [
                          'envoiceCustomeInfo',
                          'selectedEnvoiceWay',
                        ].includes(currentID),
                      }"
                      class="cursor-pointer text-nine"
                    >
                      <v-icon class="mr-1" dense>mdi-plus</v-icon
                      >{{ $t("order_step_3_add_receiver_address") }}
                    </div>
                  </v-form>
                </div>
                <div
                  class="grey-1 pa-5"
                  :key="envoiceWay.type"
                  v-if="
                    envoiceWay.type == 'triplicate' &&
                    selectedEnvoice == 'triplicate'
                  "
                >
                  <v-form
                    :class="$vuetify.breakpoint.xs ? '' : 'px-5'"
                    v-model="invalidInvoiceError"
                  >
                    <div :class="$vuetify.breakpoint.xs ? '' : 'px-5'">
                      <div class="text-nine font-weight-bold">
                        {{ $t("order_step_3_business_operator_info") }}*
                      </div>
                      <v-text-field
                        id="company"
                        v-model="company"
                        background-color="white"
                        color="primary-1"
                        :items="donateOrganization"
                        :label="$t('order_step_3_corp_name')"
                        outlined
                        class="mt-5"
                        :error="
                          hasInvoiceInvalid &&
                          !!invalidInvoiceError.company &&
                          company === ''
                        "
                        :error-messages="
                          hasInvoiceInvalid && !!invalidInvoiceError.company
                            ? [invalidInvoiceError.company]
                            : null
                        "
                        @change="invoiceFormRequired"
                        @blur="invoiceFormRequired"
                      >
                        <template #message="{ message }">
                          {{ $t(message) }}
                        </template>
                      </v-text-field>
                      <v-col cols="12" sm="6" class="pa-0">
                        <v-text-field
                          id="companyCode"
                          v-model="companyCode"
                          background-color="white"
                          color="primary-1"
                          :items="donateOrganization"
                          :label="$t('order_step_3_corp_number')"
                          outlined
                          :error="
                            hasInvoiceInvalid &&
                            !!invalidInvoiceError.companyCode &&
                            companyCode === ''
                          "
                          :error-messages="
                            hasInvoiceInvalid &&
                            !!invalidInvoiceError.companyCode
                              ? [invalidInvoiceError.companyCode]
                              : null
                          "
                          @change="invoiceFormRequired"
                          @blur="invoiceFormRequired"
                        >
                          <template #message="{ message }">
                            {{ $t(message) }}
                          </template>
                        </v-text-field>
                      </v-col>
                    </div>
                  </v-form>
                </div>
              </template>
            </v-radio-group>
            <ul class="mt-5">
              <li class="text-eight text-left customMark">
                {{ $t("order_step_3_invoice_note") }}
              </li>
            </ul>
          </v-col>
        </CustomCard>
      </template>
      <template v-slot:orderRecaptcha v-if="!!campaign.recaptchaEnable">
        <div
          :class="`mt-3 px-10 d-flex justify-end ${
            isSubmit && !token ? 'is-need-value' : ''
          }`"
          id="recaptcha"
        >
          <recaptcha
            ref="recaptcha"
            :siteKey="siteKey"
            @verify="verifyMethod"
          />
        </div>
      </template>
      <template v-slot:orderFooter>
        <v-col cols="12" sm="6" class="d-flex align-center">
          <template>
            <span class="text-nine">{{ $t("order_step_3_total_price") }}</span>
            <span v-if="$vuetify.breakpoint.xs" class="primary-1--text ml-1">
              <h2>
                NT.
                {{ total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
              </h2>
            </span>
            <div v-else class="ml-3 align-self-end primary-1--text">
              <h2>
                NT.
                {{ total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
              </h2>
            </div>
          </template>
        </v-col>
        <v-col cols="12" sm="6" class="pr-2 d-flex justify-space-between">
          <v-btn
            :class="`font-weight-bold flex-grow-1 ${
              isSubmit || loadingOverlay ? 'is-disabled' : ''
            }`"
            @click="preStep()"
            :disabled="isSubmit || loadingOverlay"
            color="primary-1"
            outlined
            depressed
            style="border: 2px solid"
            :large="$vuetify.breakpoint.xs"
            :x-large="!$vuetify.breakpoint.xs"
          >
            {{ $t("order_prev_step") }}
          </v-btn>
          <v-btn
            :class="`nextBtn ml-2 flex-1 flex-grow-1 ${
              isSubmit || loadingOverlay ? 'disabledBtn' : ''
            }`"
            @click="nextStep()"
            depressed
            :disabled="isSubmit || loadingOverlay"
            :large="$vuetify.breakpoint.xs"
            :x-large="!$vuetify.breakpoint.xs"
          >
            {{
              $t(`order_step_3_pay_cta${campaign.isLottery ? "_lottery" : ""}`)
            }}
          </v-btn>
        </v-col>
      </template>
    </OrderTemplate>
  </div>
</template>

<script>
import OrderTemplate from "./OrderTemplate.vue";
import TicketTable from "./components/TicketsTable.vue";
import RegionSelect from "@/views/auth/components/RegionSelect.vue";
import Recaptcha from "@/components/Recaptcha";

// import { getProducts } from "@/api/static";
import { mapActions, mapGetters } from "vuex";
import TM from "@/api/ticket-management";
import OM from "@/api/order-management";
import CC from "@/api/config-center";
import donateOrganizationJS from "@/static/donateOrganization.js";
import { CurrentReservedMixins } from "@/shared/mixins";
import { isIOSInAppBrowser } from "@/shared/webViewRedirect";
import jwt_decode from "jwt-decode";
import { decrypt as AESdecrypt } from "../../vendor/AEScrypto";

export default {
  mixins: [CurrentReservedMixins],
  components: {
    OrderTemplate,
    TicketTable,
    RegionSelect,
    Recaptcha,
  },
  data() {
    return {
      shippingFee: 0,
      abortController: new AbortController(),
      abortInfoController: new AbortController(),
      infoTimer: null,
      hasPickupInvalid: true,
      invalidPickupError: {},
      invalidInvoiceError: {},
      hasInvoiceInvalid: true,
      welfareFee: 0,
      siteKey: null,
      token: null,
      isErrorToBack: false,
      isSubmit: false,
      currentID: "",
      isOrderConfirmed: false,
      isOrderSuccessed: false,
      reserveData: null,
      detectCloseInterval: null,
      loadingOverlay: false,
      processingCC: false,
      reserveTickets: [],
      years: ["2022", "2023"],
      months: ["1月", "2月"],
      currentTxStatus: "",
      payWays: [
        {
          type: "CC",
        },
        {
          type: "ATM",
        },
      ],
      envoiceWays: [
        {
          type: "donate",
          name: this.$t("order_step_3_donate_name"),
        },
        {
          type: "duplicate",
          name: this.$t("order_step_3_donate_personal_title"),
          descript: this.$t("order_step_3_donate_personal_content"),
        },
        {
          type: "triplicate",
          name: this.$t("order_step_3_donate_corp_title"),
          descript: this.$t("order_step_3_donate_corp_content"),
        },
      ],
      selectedGetWay: { type: "none" },
      selectedPayWay: { type: "" },
      selectedEnvoiceWay: { type: "" },
      timer: {},
      selectedGetValue: "",
      selectedPayValue: "",
      open3DTabLink: null, // 是否已另開啟3D驗證
      pickupInfo: {
        name: "",
        mobile: "",
        postalCode: "",
        county: "",
        district: "",
        address: "",
      },
      donation: "",
      receiptInfo: {
        name: "",
        mobile: "",
        postalCode: "",
        county: "",
        district: "",
        address: "",
      },
      company: "",
      companyCode: "",
      selectedPickupAddress: "1",
      selectedEnvoiceAddress: "",
      selectedEnvoice: "1",
      loadingUserInfo: false,
      maskedUserInfo: {},
      loadingCCList: false,
      ccList: [],
      getWays: [],
      loadCCFailed: false,
      cc3DUrl: "",
      getcc3DUrl: false,
      showInAppBrowserWarning: false,
    };
  },
  computed: {
    ...mapGetters({
      countdown: "order/timer",
      campaign: "event/campaign",
      sessionInfo: "session/sessionInfo",
      tickets: "order/boughtTickets",
      selectedArea: "order/selectedArea",
      seatAssignment: "order/seatAssignment",
      areaAssignment: "order/areaAssignment",
      reserveResponse: "order/reserveResponse",
      updateResponse: "order/updateResponse",
      pageData: "order/pageData",
      isPopState: "order/isPopState",
      reCaptchaStatus: "user/recaptchaStatus",
      productData: "session/productData",
      ticketsData: "session/ticketsData",
    }),
    getWayOptions() {
      const total = this.reserveResponse.products.reduce(
        (accr, ticket, value) => {
          accr += ticket.count;
          return accr;
        },
        0
      );
      let options = [
          {
            type: "famiport",
            name: this.$t("order_step_3_fami_pickup_title"),
            descript: this.$t("order_step_3_fami_pickup_content"),
            tips: this.$t("order_step_3_fami_pickup_tip"),
          },
          {
            type: "ibon",
            name: this.$t("order_step_3_ibon_pickup_title"),
            descript: this.$t("order_step_3_ibon_pickup_content"),
            tips: this.$t("order_step_3_ibon_pickup_tip"),
          },
          {
            type: "post",
            name: this.$t("order_step_3_post_pickup_title"),
            descript: this.$t("order_step_3_post_pickup_content"),
            other: this.$t("order_step_3_post_pickup_tip", {
              shippingFee: this.shippingFee,
            }),
          },
          {
            type: "eTicket",
            name: this.$t("eticket"),
          },
        ],
        campaignOptions = {
          payment: this.$store.state.event.campaign.payment || [],
          pickup: this.$store.state.event.campaign.pickUp || [],
          receipt: this.$store.state.event.campaign.receipt || [],
        };

      return options.filter((getWay) => {
        return (
          campaignOptions.pickup.includes(getWay.type) &&
          (getWay.type !== "ibon" || (getWay.type === "ibon" && total <= 4))
        );
      });
    },
    isInPostLimit() {
      let end = new Date(this.sessionInfo.sessionEnd).valueOf();
      let dt = new Date().valueOf();

      return end - 86400000 * 9 > dt;
    },
    thead() {
      const defaultHead = [
        {
          name: "name",
          label: this.$t(
            `orderlist_product_name${this.campaign.isLottery ? "_lottery" : ""}`
          ),
          col: this.areaAssignment && !this.seatAssignment ? 3 : 5,
          class: this.$vuetify.breakpoint.xs ? "pl-4" : "px-8",
        },
        {
          name: "count",
          label: this.$t(
            `orderlist_product_count${
              this.campaign.isLottery ? "_lottery" : ""
            }`
          ),
          col: 2,
          class: this.$vuetify.breakpoint.xs
            ? "text-right pr-4"
            : "text-center",
        },
        {
          name: "price",
          label: this.$t("order_step_2_product_price"),
          col: this.areaAssignment && !this.seatAssignment ? 2 : 3,
          class: this.$vuetify.breakpoint.xs ? "pl-4 mt-2" : "text-center",
        },
        {
          name: "sum",
          label: this.$t("orderlist_product_sum"),
          col: 2,
          class: this.$vuetify.breakpoint.xs
            ? "text-right pr-4 mt-2"
            : "text-center",
        },
      ];
      return this.areaAssignment && this.seatAssignment
        ? [
            {
              name: "ticketAreaName",
              label: this.$t(
                `orderlist_ticketarea_name${
                  this.campaign.isLottery ? "_lottery" : ""
                }`
              ),
              col: 6,
              colSm: 3,
              class: this.$vuetify.breakpoint.xs ? "pl-4" : "px-8",
            },
            {
              name: "seat",
              label: this.$t("orderlist_ticketarea_seat"),
              col: 6,
              colSm: 3,
              class: this.$vuetify.breakpoint.xs
                ? "text-right pr-4"
                : "text-center",
            },
            {
              name: "name",
              label: this.$t(
                `orderlist_product_name${
                  this.campaign.isLottery ? "_lottery" : ""
                }`
              ),
              col: 6,
              colSm: 3,
              class: this.$vuetify.breakpoint.xs ? "pl-4 mt-4" : "text-center",
            },
            {
              name: "price",
              label: this.$t("orderlist_product_sum"),
              col: 6,
              colSm: 3,
              class: this.$vuetify.breakpoint.xs
                ? "text-right pr-4 mt-4"
                : "text-center",
            },
          ]
        : this.areaAssignment && !this.seatAssignment
        ? [
            {
              name: "ticketAreaName",
              label: this.$t(
                `orderlist_ticketarea_name${
                  this.campaign.isLottery ? "_lottery" : ""
                }`
              ),
              col: 12,
              colSm: 3,
              class: this.$vuetify.breakpoint.xs ? "pl-4" : "px-8",
            },
            ...defaultHead,
          ]
        : defaultHead;
    },
    steps() {
      return !this.areaAssignment
        ? [
            this.$t("order_step_1"),
            this.$t("order_step_2"),
            this.$t("order_step_3"),
          ]
        : [
            this.$t(
              `order_seat_step_1${this.campaign.isLottery ? "_lottery" : ""}`
            ),
            this.$t(
              `order_seat_step_2${this.campaign.isLottery ? "_lottery" : ""}`
            ),
            this.$t("order_seat_step_3"),
            this.$t(
              `order_seat_step_4${this.campaign.isLottery ? "_lottery" : ""}`
            ),
          ];
    },
    donateOrganization() {
      return donateOrganizationJS;
    },
    total: {
      get() {
        const amt = this.updateResponse.total || 0;
        return amt + (this.selectedGetValue === "post" ? this.shippingFee : 0);
      },
      cache: false,
    },
    amount() {
      return this.tickets.reduce((acc, { count }) => acc + count, 0);
    },
    isGetSelect() {
      if (!this.getWays.length || this.campaign.pickUp[0] === "none")
        return true;
      else {
        if (this.selectedGetValue !== "") {
          if (this.selectedGetWay.type === "post") {
            if (this.selectedPickupAddress === "2") {
              return (
                Object.values(this.pickupInfo).filter(
                  (value) => !value || value === ""
                ).length === 0
              );
            }
            return true;
          } else {
            if (!this.campaign.receipt && !this.welfareFee) {
              this.selectedEnvoiceWay = { type: "" };
              this.receiptInfo = {
                name: "",
                mobile: "",
                postalCode: "",
                county: "",
                district: "",
                address: "",
              };
            }
            return true;
          }
        }
        return false;
      }
    },
    needEnvoice: {
      get() {
        return (
          this.envoiceWays.length &&
          (this.welfareFee ||
            !!this.campaign.receipt ||
            this.selectedGetValue === "post")
        );
      },
      cache: false,
    },
    isEnvoiceSelect() {
      if (!this.needEnvoice) {
        return true;
      } else {
        if (this.selectedEnvoice) {
          if (this.selectedEnvoice === "donate") return this.donation;
          if (this.selectedEnvoice === "duplicate") {
            return (
              this.selectedEnvoiceAddress === "1" ||
              (this.selectedEnvoiceAddress === "2" &&
                !Object.values(this.receiptInfo).filter((value) => !value)
                  .length)
            );
          }
          if (this.selectedEnvoice === "triplicate") {
            return this.company && this.companyCode;
          }
        }
        return false;
      }
    },
    isPaySelect() {
      if (!this.payWays.length) return true;
      else {
        if (this.selectedPayWay.type == "CC")
          return this.ccList.length && this.selectedPayWay.type;
        return this.selectedPayWay.type;
      }
    },
    userInfoValid() {
      return (
        this.maskedUserInfo.userName &&
        this.maskedUserInfo.userName !== "" &&
        this.maskedUserInfo.address &&
        this.maskedUserInfo.address !== ""
      );
    },
    getInfoValid() {
      let result = true;
      for (let i in this.pickupInfo) {
        if (!this.pickupInfo[i] || this.pickupInfo[i] === "") result = false;
      }
      return result;
    },
    receiptInfoValid() {
      let result = true;
      for (let i in this.receiptInfo) {
        if (!this.receiptInfo[i] || this.receiptInfo[i] === "") result = false;
      }
      return result;
    },
    canNextStep() {
      const pickupValid =
        this.isGetSelect &&
        (this.selectedGetWay.type !== "post" ||
          (this.selectedGetWay.type === "post" &&
            this.selectedPickupAddress === "1" &&
            this.userInfoValid) ||
          (this.selectedPickupAddress === "2" && this.getInfoValid));
      const invoiceValid =
        this.isEnvoiceSelect &&
        (this.selectedEnvoiceAddress === "" ||
          (this.selectedEnvoiceAddress === "1" && this.userInfoValid) ||
          (this.selectedEnvoiceAddress === "2" && this.receiptInfoValid));
      const recaptchaValid =
        !this.campaign.recaptchaEnable ||
        (this.campaign.recaptchaEnable && !!this.token);

      return this.isPaySelect && pickupValid && invoiceValid && recaptchaValid;
    },
    countDeductAmount() {
      return this.culturePointResponse && this.culturePointResponse.orderInfo
        ? this.culturePointResponse.orderInfo[0].tickets.reduce(
            (accr, t) => accr + t.deductAmount,
            0
          )
        : 0;
    },
  },
  watch: {
    selectedPickupAddress: {
      immediate: true,
      deep: true,
      handler(newVal, old) {
        this.$forceUpdate();
        if (newVal && newVal !== old && this.isSubmit) {
          this.isSubmit = false;
          this.currentID = "";
          this.$forceUpdate();
        }
      },
    },
    selectedPayValue(newVal) {
      this.selectedPayWay.type = newVal;
    },
    isPopState: {
      deep: true,
      handler: function (newVal, old) {
        if (old !== newVal && !newVal) {
          this.init();
        }
      },
    },
    reCaptchaStatus: async function (newVal) {
      if (newVal === "error") {
        let [{ data: campaignInfo }, getInfosErr] = await CC.getInfos({
          eventId: [this.$route.params.eventId],
        });

        this.setCampaign({ ...campaignInfo.result.event[0] });
      }
    },
    selectedEnvoice: {
      immediate: true,
      deep: true,
      handler: function (newVal, old) {
        if (old !== newVal && newVal === "duplicate") {
          if (this.selectedEnvoiceAddress === "")
            this.selectedEnvoiceAddress = "1";
        }
      },
    },
  },
  metaInfo() {
    return {
      title: `${this.$t("order_step_3_title")} | ${
        this.sessionInfo.name || ""
      } | ${this.$t("app_name")}`,
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: `${this.$t("order_step_3_title")} | ${
              this.sessionInfo.name || ""
            } | ${this.$t("app_name")}`,
            url: window.location.href,
          },
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show",
      closeDialog: "dialog/close",
      doUpdateOrder: "order/updateOrder",
      setCampaign: "event/setCampaign",
      setRecaptchaStatus: "user/setRecaptchaStatus",
      setOrderComplete: "order/setOrderComplete",
      reserveTicket: "order/reserveTicket",
    }),
    dateFormat(date, format) {
      if (!date) return "";
      const year = date.substring(0, 4);
      const month = date.substring(4, 6);
      if (format === "MM/YY") {
        return `${month}/${year.substring(2, 4)}`;
      }
    },
    doSelectGet(way) {
      this.selectedGetWay = { ...way };
      if (this.isSubmit) {
        this.isSubmit = false;
        this.currentID = "";
      }
      // this.$set(this.selectedGetValue, way.type, true);
      if (way.type === "post" && this.maskedUserInfo.country !== "Taiwan") {
        this.selectedPickupAddress = "2";
      }
      this.$forceUpdate();
    },
    renderGetWay(name, getWay) {
      let newGetWay = {
        ...getWay,
      };
      switch (getWay.type) {
        case "ibon":
          newGetWay = {
            name: this.$t("order_step_3_ibon_pickup_title"),
            other: this.$t("order_step_3_ibon_pickup_tip"),
            discript: this.$t("order_step_3_ibon_pickup_content"),
          };
          break;
        case "post":
          break;
        case "famiport":
          break;
      }
    },
    verifyMethod(response) {
      this.token = response;
    },
    setNewInvoiceInfo() {
      this.selectedEnvoiceAddress = "2";
      this.receiptInfo = {
        name: "",
        mobile: "",
        postalCode: "",
        county: "",
        district: "",
        address: "",
      };
    },
    setNewUserInfo() {
      this.selectedPickupAddress = "2";
      this.pickupInfo = {
        name: "",
        mobile: "",
        postalCode: "",
        county: "",
        district: "",
        address: "",
      };
    },
    async getShippingFee() {
      const { data } = await TM.getShippingFee(this.reserveResponse.orderId);
      if (data.errCode === "00") {
        this.shippingFee = data.shippingFee;
        this.$forceUpdate();
      }
    },
    async init() {
      if (Object.keys(this.reserveResponse).length === 0) {
        this.$router
          .push({
            name: "Order2",
            params: {
              eventId: this.$route.params.eventId,
              sessionId: this.$route.params.sessionId,
            },
          })
          .catch(() => {});
        return;
      }

      await this.getMaskedUserInfo();
      await this.getCampaignOptions();
      await this.getShippingFee();

      if (this.reserveResponse.welfareFee || this.updateResponse.welfareFee) {
        this.welfareFee = true;
      }

      if (!!this.pageData) {
        this._data = { ...this._data, ...Object.assign(this.pageData) };
        this.setPageData(null);
      }

      this.$store.dispatch("setOverlayLoading", false);

      this.$forceUpdate();
      this.$gtm.trackView(
        `付款結帳-${this.sessionInfo.name}`,
        this.$route.path
      );
      if (this.campaign.gaId) {
        this._initGtag(this.campaign.gaId);
      }
    },
    async initTickets(updateData) {
      const $this = this;
      if (this.areaAssignment && this.seatAssignment) {
        const seats = this.reserveResponse.products.reduce(
          (accr, reserve, index) => {
            let seats = reserve.seats.reduce((ary, seat, seatIdx) => {
              let product = this.productData.find(
                (p) => p.productId === reserve.id
              );
              let newSeat = {
                ...seat,
                ...product,
                idx: reserve.idx,
                price: reserve.price,
                productId: reserve.productId,
              };

              if (
                !!updateData &&
                updateData.products[index].culturePointTickets
              ) {
                newSeat = {
                  ...newSeat,
                  ...updateData.products[index].culturePointTickets[seatIdx],
                  price: reserve.price,
                };
              }

              ary.push(newSeat);
              return ary;
            }, []);
            accr = accr.concat(seats);
            return accr;
          },
          []
        );

        this.reserveTickets = seats.map((seat, i) => {
          let ticket = $this.tickets.find(
            (t) => t.productId === seat.productId
          );
          return { ...seat, ...ticket };
        });
      } else {
        this.reserveTickets = this.reserveResponse.products.reduce(
          (accr, reserve, index) => {
            let selectedTicket = $this.tickets.find(
              (t) => t.productId === reserve.productId
            );

            let newTicket = {
              ...reserve,
              ...selectedTicket,
            };

            accr.push(newTicket);
            return accr;
          },
          []
        );
      }
    },
    selectPayWay(type) {
      if (type === "CC") {
        this.getUserCCInfo();
      }
      if (type === "ATM") this.ccList = [];

      this.selectedPayWay.type = type;
      // this.$forceUpdate();
    },
    getCampaignOptions() {
      let campaignOptions = {
        payment: this.$store.state.event.campaign.payment || [],
        pickup: this.$store.state.event.campaign.pickUp || [],
        receipt: this.$store.state.event.campaign.receipt || [],
      };

      this.getWays = this.getWayOptions.filter((getWay) =>
        campaignOptions.pickup.includes(getWay.type)
      );
      if (this.amount > 4) {
        this.getWays = this.getWayOptions.filter(
          (getWays) => getWays.type !== "famiport" && getWays.type !== "ibon"
        );
      }
      this.payWays = this.payWays.filter((payWay) =>
        campaignOptions.payment.includes(payWay.type)
      );
      this.envoiceWays =
        campaignOptions.receipt || this.welfareFee ? this.envoiceWays : [];
    },
    receiptInfoContent(type) {
      if (type === "donate") {
        return { organization: this.donation.split(" ")[0] };
      }
      if (type === "duplicate") return this.receiptInfo;
      if (type === "triplicate")
        return {
          organization: this.company,
          taxIdNumber: this.companyCode,
        };

      return null;
    },
    paymentInfoContent() {
      if (this.selectedPayWay.type === "CC") {
        if (this.ccList.find((cc) => cc.isDefault === "Y").id)
          return {
            cardId: this.ccList.find((cc) => cc.isDefault === "Y").id,
          };
      }
      return null;
    },
    async updateOrder() {
      let params = {
        ...(this.isGetSelect && {
          pickupInfo: {
            type: this.selectedGetWay.type,
            content:
              this.selectedGetWay.type === "post" &&
              this.selectedPickupAddress == "2"
                ? this.pickupInfo
                : null,
          },
        }),
        ...(this.selectedPayWay.type !== "" && {
          paymentInfo: {
            type: this.selectedPayWay.type,
            content: this.paymentInfoContent(),
          },
        }),
        ...(this.selectedEnvoice !== "" &&
          this.needEnvoice && {
            receiptInfo: {
              type: this.selectedEnvoice,
              content:
                this.selectedEnvoice === "duplicate" &&
                this.selectedEnvoiceAddress == "1"
                  ? null
                  : this.receiptInfoContent(this.selectedEnvoice),
            },
          }),
      };

      if (this.campaign.pickUp[0] === "serial") {
        params.pickupInfo = {
          type: "serial",
        };
      }

      if (this.$store.state.event.campaign.payment.includes("FREE")) {
        params.paymentInfo = {
          type: "FREE",
        };
      }

      const { data: updateResponse } = await TM.ticketUpdate({
        orderId: this.reserveResponse.orderId,
        ...params,
      });

      return updateResponse;
    },
    async preStep() {
      this.setPageData(null);
      this.$router.push({ name: "Order2" }).catch(() => {});
    },
    async getOrderState() {
      const { data: getOrderStatusRes } = await TM.getOrderStatus(
        this.reserveResponse.orderId,
        this.abortController
      );

      if (getOrderStatusRes.status === "SUCCESS") {
        this.orderSuccessed();
      } else if (getOrderStatusRes.status === "PROCESS") {
        // todo if (cc)
        // 信用卡授權中畫面;
        if (this.selectedPayWay.type === "CC") this.processingCC = true;
        this.setOrderComplete(2);
        this.get3dCCLink();
        return;
      } else if (getOrderStatusRes.status === "RELEASED") {
        this.isSubmit = false;
        this.showDialog({
          error: true,
          title: "",
          content: this.$t("order_step_3_order_fail"),
          action: () => {
            this.$router
              .push({
                name: "Order1",
                params: {
                  eventId: this.$route.params.eventId,
                  sessionId: this.$route.params.sessionId,
                },
              })
              .catch((error) => {});
            window.isProccess = false;
            window.orderCanceled = false;
          },
        });
        this.loadingOverlay = false;
        this.$store.dispatch("setOverlayLoading", false);
      } else {
        // ORDER_CREATED or others
        setTimeout(() => {
          this.getOrderState();
        }, 1000);
      }
    },
    pickupFormRequired() {
      this.invalidPickupError = {};
      for (var i in this.pickupInfo) {
        let item = this.pickupInfo[i];
        if (!item || item === "") {
          this.invalidPickupError[i] = "field_required";
        } else if (i === "email" && !/.+@.+\..+/.test(item)) {
          valid = false;
          this.invalidPickupError[i] = "email_format_error";
        }
      }
      this.hasPickupInvalid = Object.keys(this.invalidPickupError).length > 0;
      return Object.keys(this.invalidPickupError).length === 0;
    },
    invoiceFormRequired() {
      this.invalidInvoiceError = {};

      if (this.selectedEnvoice === "donate" && this.donation === "") {
        this.invalidInvoiceError["donation"] = "field_required";
      } else if (
        this.selectedEnvoice === "duplicate" &&
        this.selectedEnvoiceAddress === "2"
      ) {
        for (var i in this.receiptInfo) {
          let item = this.receiptInfo[i];
          if (!item || item === "" || !/^(?!\s*$).+/.test(item)) {
            this.invalidInvoiceError[i] = "field_required";
          } else if (i === "email" && !/.+@.+\..+/.test(item)) {
            valid = false;
            this.invalidInvoiceError[i] = "email_format_error";
          }
        }
      } else if (this.selectedEnvoice === "triplicate") {
        let keys = ["company", "companyCode"];
        for (var i in keys) {
          let key = keys[i];
          if (this[key] === "" || !/^(?!\s*$).+/.test(this[key])) {
            this.invalidInvoiceError[key] = "field_required";
          }
        }
      }
      this.hasInvoiceInvalid = Object.keys(this.invalidInvoiceError).length > 0;
      return Object.keys(this.invalidInvoiceError).length === 0;
    },
    async nextStep() {
      if (!this.canNextStep) {
        let elem = "";

        if (this.getWays.length && !this.isGetSelect) {
          this.currentID = "selectedGetWay";
          elem = document.querySelector("#selectedGetWay");
        } else if (
          this.selectedGetWay.type === "post" &&
          (!this.selectedPickupAddress ||
            this.selectedPickupAddress === "" ||
            this.selectedPickupAddress === "1") &&
          !this.userInfoValid &&
          !this.pickupFormRequired()
        ) {
          //
          this.currentID = "pickupCustomeInfo";
          elem = document.querySelector("#pickup-custom");
        } else if (
          this.selectedGetWay.type === "post" &&
          this.selectedPickupAddress === "1" &&
          !(
            this.maskedUserInfo.userName &&
            this.maskedUserInfo.mobile &&
            this.maskedUserInfo.address
          ) &&
          !this.pickupFormRequired()
        ) {
          this.pickupFormRequired();
          this.hasPickupInvalid = true;
          this.currentID = "pickupCustomeInfo";
          elem = document.querySelector("#pickup-custom");
        } else if (
          this.payWays.length &&
          this.$store.state.event.campaign.payment &&
          !this.$store.state.event.campaign.payment.includes("FREE") &&
          this.selectedPayWay.type === ""
        ) {
          this.currentID = "selectedPayWay";
          elem = document.querySelector("#selectedPayWay");
        } else if (this.selectedPayWay.type === "CC" && !this.ccList.length) {
          this.currentID = "add-credit-card";
          elem = document.querySelector("#add-credit-card");
        } else if (this.needEnvoice) {
          this.currentID = "selectedEnvoiceWay";
          elem = document.querySelector("#selectedEnvoiceWay");
        } else if (
          this.selectedEnvoice !== "" &&
          (!this.selectedEnvoiceAddress ||
            this.selectedEnvoiceAddress === "" ||
            this.selectedEnvoiceAddress === "1") &&
          !this.userInfoValid &&
          !this.pickupFormRequired()
        ) {
          this.currentID = "envoiceCustomeInfo";
          elem = document.querySelector("#envoice-custom");
        } else if (this.selectedEnvoice !== "" && !this.invoiceFormRequired()) {
          this.invoiceFormRequired();
          this.hasInvoiceInvalid = true;
          this.currentID = "envoiceCustomeInfo";
          elem = document.querySelector("#envoiceCustomeInfo");
        } else if (
          this.campaign.recaptchaEnable &&
          this.reCaptchaStatus !== "success"
        ) {
          elem = document.querySelector("#recaptcha");
        }

        const rect = elem.getBoundingClientRect();
        // console.log(elem, window.scrollTop, elem.parentNode.offsetTop, rect)
        window.scrollTo({
          left: 0,
          top: elem
            ? window.scrollY + rect.top - 200
            : document.body.clientHeight,
          behavior: "smooth",
        });
        return;
      }

      this.isOrderConfirmed = true;
      this.isSubmit = true;
      this.loadingOverlay = true;
      this.$forceUpdate();

      let updateResult = await this.updateOrder();

      if (updateResult.errCode === "999") {
        window.isErrorToBack = true;
        this.showDialog({
          alert: true,
          title: this.$t("activity_busy_title"),
          content: this.$t("activity_busy_content"),
        });
        setTimeout(() => {
          this.$store.dispatch("setOverlayLoading", false);
          window.location.href = `/order/${this.$route.params.eventId}/${this.$route.params.sessionId}`;
        }, 3000);
        return;
      }
      if (updateResult.errCode == "00") {
        await this.doConfirm();
      } else {
        if (updateResult.errCode == "117") {
          this.showDialog({
            error: true,
            title: this.$t("order_step_3_creditcard_fail_title"),
            content: this.$t("order_step_3_creditcard_fail_content"),
          });
        } else if (updateResult.errCode == "120") {
          this.showDialog({
            error: true,
            title: this.$t("order_step_3_payment_fail_title"),
            content: this.$t("order_step_3_payment_fail_content"),
          });
        } else {
          this.showDialog({
            alert: true,
            content: `<div class="pa-6 text-center font-weight-bold">
              <img
                src="/image/ic-warning@3x.png"
                alt=""
                style="width:80px"
              />
              <div class="mt-5">${this.$t(
                "order_step_3_update_fail_text"
              )}</div>
            </div>`,
          });
        }
        this.isSubmit = false;
        this.loadingOverlay = false;
      }
    },
    async doConfirm() {
      const { data } = await TM.ticketConfirm({
        orderId: this.reserveResponse.orderId,
        recaptchaToken: this.token,
      });
      if (data.errCode === "999") {
        window.isErrorToBack = true;
        this.showDialog({
          alert: true,
          title: this.$t("activity_busy_title"),
          content: this.$t("activity_busy_content"),
        });
        setTimeout(() => {
          this.$store.dispatch("setOverlayLoading", false);
          window.location.href = `/order/${this.$route.params.eventId}/${this.$route.params.sessionId}`;
        }, 3000);
        // this.$router.push({ name: "Order1" }).catch(() => { });
        return;
      }
      // console.log(`${String.fromCodePoint(128049)} [TM] confirm`, data);
      if (data.errCode === "00") {
        this.getOrderState();
      } else {
        if (data.errCode == "138") {
          this.showDialog({
            error: true,
            title: this.$t("order_step_3_only_creditcard_fail_title"),
            content: this.$t("order_step_3_only_creditcard_fail_content"),
          });
        }
        if (data.errCode === "" || data.errCode === "130") {
          this.showDialog({
            error: true,
            title: "驗證失敗",
            content: "請再重新驗證",
          });
        }
        this.isSubmit = false;
        this.loadingOverlay = false;
      }
      // todo else of confirm fail
    },
    backToOrder() {
      this.$router
        .push({
          name: "Order1",
          params: {
            eventId: this.$route.params.eventId,
            sessionId: this.$route.params.sessionId,
          },
        })
        .catch((error) => {});
    },
    async timeout(timer = 5000) {
      return new Promise((resolve) => {
        setTimeout(resolve, timer);
      });
    },
    async retryGetOrderInfo() {
      await this.timeout();
      if (this.isAbort) return;
      return await this.apiGetOrderInfo();
    },
    async get3dCCLink() {
      if (this.status === "release") return;

      this.infoTimer = setTimeout(async () => {
        let result = await this.apiGetOrderInfo();
        if (!result || typeof result !== "object") return;

        this.currentTxStatus = result.txStatus || "";

        // 當狀態為空、WAITING 或 3D 時視為待定狀態
        while (["", "WAITING", "3D"].includes(this.currentTxStatus)) {
          // 處理 3D 驗證跳轉彈窗
          result = await this.retryGetOrderInfo();
          this.currentTxStatus = result.txStatus || "";
          if (result.txStatus === "3D" && !this.getcc3DUrl && result.cc3DUrl) {
            this.cc3DUrl = result.cc3DUrl;
            this.getcc3DUrl = true;
            this.showDialog({
              error: true,
              title: this.$t("order_step_3_cc_verify_title"),
              content: this.$t("order_step_3_cc_verify_content"),
              button: this.$t("layout_notification_confirm"),
              outerLink: result.cc3DUrl,
              action: () => {
                this.open3DTabLink = true;
              },
            });
          }
          // 若狀態仍為空、等待中，或尚未取得 3D 連結，則繼續輪詢
          if (!this.getcc3DUrl) {
            this.get3dCCLink();
          }
        }
      }, 3000);
    },
    async apiGetOrderInfo() {
      if (this.status === "release") return;

      let { data: getOrderInfoRes } = await OM.getPurchaseInfo(
        this.reserveResponse.orderId,
        this.abortInfoController
      );
      if (getOrderInfoRes.errCode == "00") {
        // ATM && atmAccount
        if (getOrderInfoRes.atmAccount) {
          this.orderSuccessed();
          return {
            ...getOrderInfoRes,
            txStatus: "SUCCESS",
          };
        } else if (getOrderInfoRes.txStatus === "SUCCESS") {
          this.orderSuccessed();
        } else if (getOrderInfoRes.txStatus === "FAILED") {
          this.orderFailed();
        }
        return getOrderInfoRes;
      } else {
        this.orderFailed();
        return false;
      }
    },
    orderSuccessed() {
      this.isSubmit = false;
      this.isOrderSuccessed = true;
      this.setOrderComplete(1);
      this.$router
        .push({
          name: "Done",
          params: { orderId: this.reserveResponse.orderId },
        })
        .catch(() => {});
    },
    orderFailed() {
      this.isSubmit = false;
      this.loadingOverlay = false;
      this.showDialog({
        alert: true,
        content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-warning@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t("order_step_3_order_fail")}</div>
          </div>`,
      });
      setTimeout(() => {
        this.$router
          .push({
            name: "Order1",
            params: { sessionId: this.$route.params.sessionId },
          })
          .catch(() => {});
      }, 3000);
    },
    emitUpdatePickupAddress(address) {
      this.pickupInfo.county = address.county;
      this.pickupInfo.district = address.district;
      this.pickupInfo.address = address.address;
      this.pickupInfo.postalCode = address.postalCode;
      this.pickupFormRequired();
    },
    emitUpdateReceiptAddress(address) {
      this.receiptInfo.county = address.county;
      this.receiptInfo.district = address.district;
      this.receiptInfo.address = address.address;
      this.receiptInfo.postalCode = address.postalCode;
      this.$nextTick();
      this.$forceUpdate();
      this.invoiceFormRequired();
    },
    getMaskedUserInfo() {
      const user = JSON.parse(Cookies.get("user"));
      const token = jwt_decode(user.access_token);

      this.maskedUserInfo = {
        userName: token.maskedUserName,
        mobile: token.maskedMobile,
        email: token.maskedEmail,
        birthday: token.maskedBirthday,
        address:
          token.encryptedAddress && token.encryptedAddress.encryptedData
            ? AESdecrypt(
                token.encryptedAddress.encryptedData,
                token.encryptedAddress.iv
              )
            : "",
        country:
          !!token.country && token.country !== "" ? token.country : "Taiwan",
      };
    },
    async getUserCCInfo() {
      this.loadingCCList = true;
      this.$forceUpdate();
      const { data: getCCresponse } = await OM.getUserCCInfo();
      if (getCCresponse.errCode === "00") {
        this.ccList = getCCresponse.ccList;
      } else {
        this.loadCCFailed = true;
      }
      this.loadingCCList = false;
      this.$store.dispatch("setOverlayLoading", false);
      this.$forceUpdate();
    },
    async updateCCInfo() {
      if (!!window.win) window.open(window.winUrl, "credit-page");
      else {
        window.win = window.open("", "credit-page");
        const { data: updateCCResponse } = await OM.updateCCInfo();
        if (updateCCResponse.errCode == "00" && updateCCResponse.url) {
          window.win.location = updateCCResponse.url;
          window.winUrl = updateCCResponse.url;
          this.detectCloseInterval = setInterval(() => {
            if (!window.win || window.win.closed) {
              this.$store.dispatch("setOverlayLoading", true);
              window.win = null;
              window.winUrl = null;
              clearInterval(this.detectCloseInterval);
              setTimeout(() => {
                this.getUserCCInfo();
              }, 3000);
            }
          }, 500);
        }
      }
    },
    async cancelTicket(to) {
      // if (this.processingCC) return;
      this.status = "release";
      const { data } = await TM.ticketRelease({
        orderId: this.reserveResponse.orderId,
        culturePointInfo: {},
      });
      this.isSubmit = false;
      this.resetCulturePoint();
      this.resetOrderState();
      this.setPageData(null);
      this.$router
        .push({
          name: to.name || "Order1",
          params: !to
            ? {
                eventId: this.$route.params.eventId,
                sessionId: this.$route.params.sessionId,
              }
            : {},
        })
        .catch((error) => {});
    },
  },
  beforeMount() {
    window.win = null;
    window.winUrl = null;
    this.siteKey = process.env.VUE_APP_RECAPTCHA_SITEKEY;
    this.showInAppBrowserWarning = isIOSInAppBrowser();
  },
  mounted() {
    if (!this.isPopState) {
      this.init();
      this.isSubmit = false;
    }
    // window.isPopState = false
  },
  updated() {
    this.setPageData(this._data);
  },
  beforeRouteLeave(to, from, next) {
    if (
      (!["Order2"].includes(to.name) &&
        this.reserveResponse.orderId &&
        !this.isOrderConfirmed &&
        !this.isOrderSuccessed &&
        this.countdown > 0) ||
      this.isSubmit
    ) {
      next(false);
      this.isAbort = true;
      alert(this.$t("leave_order"));
      if (this.getcc3DUrl) {
        this.closeDialog();
      }
      this.abortController.abort();
      this.abortInfoController.abort();
      if (this.infoTimer) clearTimeout(this.infoTimer);
      this.cancelTicket(to);
      return false;
    }

    window.isErrorToBack = false;
    next();
  },
  beforeDestroy() {
    this.setRecaptchaStatus("");
    clearTimeout(this.timer);
    clearInterval(this.detectCloseInterval);
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .radioStyle {
    border-radius: 5px;
    border: 2px solid #c4c4c4;
    color: #c4c4c4;

    .v-label {
      flex-direction: row;
      align-items: center;
    }

    &:not(.v-item--active) .v-label .primary-1--text {
      color: $grey-1 !important;
    }

    .getWayAppend {
      margin-top: 0;
    }

    label,
    .mdi-radiobox-blank,
    .mdi-information-outline {
      color: #c4c4c4;
    }

    .v-input--selection-controls__input {
      margin-right: 12px;
    }

    &.v-item--active {
      border: 2px solid $primary-dark;

      label {
        color: #444;
      }

      .getWayName,
      .getWayAppend {
        font-weight: 500;
      }

      .getWayAppend,
      .mdi-information-outline {
        color: $primary-1;
      }
    }

    @media screen and (max-width: 600px) {
      .v-label,
      .v-label {
        flex-direction: column;
        align-items: start;
      }

      .getWayAppend {
        align-items: start;
        margin-top: 12px;
        font-weight: 500;
      }
    }
  }
}

.flower-spinner,
.flower-spinner * {
  box-sizing: border-box;
}

.flower-spinner {
  height: 70px;
  width: 70px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.flower-spinner .dots-container {
  height: calc(70px / 7);
  width: calc(70px / 7);
}

.flower-spinner .smaller-dot {
  background: $primary-dark;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  animation: flower-spinner-smaller-dot-animation 2.5s 0s infinite both;
}

.flower-spinner .bigger-dot {
  background: $primary-dark;
  height: 100%;
  width: 100%;
  padding: 10%;
  border-radius: 50%;
  animation: flower-spinner-bigger-dot-animation 2.5s 0s infinite both;
}

@keyframes flower-spinner-bigger-dot-animation {
  0%,
  100% {
    box-shadow: $primary-dark 0px 0px 0px, $primary-dark 0px 0px 0px,
      $primary-dark 0px 0px 0px, $primary-dark 0px 0px 0px,
      $primary-dark 0px 0px 0px, $primary-dark 0px 0px 0px,
      $primary-dark 0px 0px 0px, $primary-dark 0px 0px 0px;
  }

  50% {
    transform: rotate(180deg);
  }

  25%,
  75% {
    box-shadow: $primary-dark 26px 0px 0px, $primary-dark -26px 0px 0px,
      $primary-dark 0px 26px 0px, $primary-dark 0px -26px 0px,
      $primary-dark 19px -19px 0px, $primary-dark 19px 19px 0px,
      $primary-dark -19px -19px 0px, $primary-dark -19px 19px 0px;
  }

  100% {
    transform: rotate(360deg);
    box-shadow: $primary-dark 0px 0px 0px, $primary-dark 0px 0px 0px,
      $primary-dark 0px 0px 0px, $primary-dark 0px 0px 0px,
      $primary-dark 0px 0px 0px, $primary-dark 0px 0px 0px,
      $primary-dark 0px 0px 0px, $primary-dark 0px 0px 0px;
  }
}

@keyframes flower-spinner-smaller-dot-animation {
  0%,
  100% {
    box-shadow: $primary-dark 0px 0px 0px, $primary-dark 0px 0px 0px,
      $primary-dark 0px 0px 0px, $primary-dark 0px 0px 0px,
      $primary-dark 0px 0px 0px, $primary-dark 0px 0px 0px,
      $primary-dark 0px 0px 0px, $primary-dark 0px 0px 0px;
  }

  25%,
  75% {
    box-shadow: $primary-dark 14px 0px 0px, $primary-dark -14px 0px 0px,
      $primary-dark 0px 14px 0px, $primary-dark 0px -14px 0px,
      $primary-dark 10px -10px 0px, $primary-dark 10px 10px 0px,
      $primary-dark -10px -10px 0px, $primary-dark -10px 10px 0px;
  }

  100% {
    box-shadow: $primary-dark 0px 0px 0px, $primary-dark 0px 0px 0px,
      $primary-dark 0px 0px 0px, $primary-dark 0px 0px 0px,
      $primary-dark 0px 0px 0px, $primary-dark 0px 0px 0px,
      $primary-dark 0px 0px 0px, $primary-dark 0px 0px 0px;
  }
}

.customMark {
  list-style-type: "※";
}

.is-need-value .v-radio {
  border-color: transparentize($accent-red, 0.5);
}

#recaptcha.is-need-value > div {
  border: 2px solid transparentize($accent-red, 0.5);
}

.expire-tag {
  display: inline-flex;
  height: 22px;
  font-size: 12px;
  border-radius: 12px;
  padding: 0 8px;
  margin-left: 8px;
  justify-content: center;
  align-items: center;

  &.active {
    color: white;
    background-color: #28bd92;
  }

  &.expired {
    color: #e64343;
    border: 1px solid #e64343;
    background-color: #fff;
  }
}

.grey-1 {
  background-color: #f2f2f2;
}
</style>
